module.exports = __webpack_public_path__ + "img/ico-dash-family.f4ace2c4.svg";